import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from './LabelText';
import PasswordRequirements from './PasswordRequirements';

const PasswordFields = (props) => {
	const { t } = useTranslation();

	const fv = useSelector(state => state.fv);
	const { lang, count, page } = props;

	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [showReq, setShowReq] = useState(false);

	useEffect(() => { // to be updated after render
		if (fv) {
			//console.log('fv', fv);
			fv.addField('password', {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					},
					regexp: {
						regexp: /^(?=.*[A-Z])(?=.*\d)(?!.*\s).{6,}$/,
						message: t('密碼需包含最少 6 個字元，至少一個大寫字母，至少一個數字，不得包含空白')
					}
				}
			});
			//console.log('fv.elements.password:', fv.elements && fv.elements['password']);

			fv.addField('confirm_password', {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫'),
					},
					identical: {
						compare: () => document.getElementById('password').value,
						message: t('密碼不一致'),
					},
				}
			});
			//console.log('fv.elements.confirm_password:', fv.elements && fv.elements['confirm_password']);
		}
	}, [fv]);

	const changePassword = (e) => {
		setPassword(e.target.value);
	}

	const handlePasswordBlur = () => {
		//console.log('handlePasswordBlur fired, fv:', fv);
		setShowReq(false);
		if (fv && typeof fv.revalidateField === 'function') {
			fv.revalidateField('password')
			  .then(status => {
				//console.log('Password revalidation status:', status);
				if (status === 'NOT_VALIDATED') {
					setShowReq(true);
				}
			  });
		} else {
			console.warn('fv.revalidateField not available');
		}
	};

	const handleFocus = () => setShowReq(true);
	const handleBlur = handlePasswordBlur;

	const handleConfirmBlur = () => {
		//console.log('handleConfirmBlur fired, fv:', fv);
		if (fv && typeof fv.revalidateField === 'function') {
			fv.revalidateField('confirm_password')
			  .then(status => {
				//console.log('Confirm password revalidation status:', status);
				if (status === 'NOT_VALIDATED') {
					setShowReq(true);
				}
			  });
		} else {
			console.warn('fv.revalidateField not available');
		}
	};

	const changeConfirmPassword = (e) => {
		setConfirmPassword(e.target.value);
	}

	return (
		<>
			<div className="quest fixtop mb-3 d-flex gap-3">
				{page.show_ques_num && (
					<div className="badge-circle badge-light-dark badge">{count}</div>
				)}
				<div className="flex-grow-1 form-group text required position-relative">
					<LabelText
						form_component={{
							label: t('密碼'),
							sub_label: ''
						}}
					/>
					<input
						type="password"
						name="password"
						placeholder={t('請輸入密碼')}
						className="form-control-sm mb-3 form-control"
						id="password"
						value={password}
						onChange={changePassword}
						onFocus={handleFocus}
						onBlur={handleBlur}
					/>
					<PasswordRequirements password={password} show={showReq} />
				</div>
			</div>
			<div className="quest fixtop mb-3 d-flex gap-3">
				{page.show_ques_num && (
					<div className="badge-circle badge-light-dark badge">{count + 1}</div>
				)}
				<div className="flex-grow-1 form-group text required">
					<LabelText
						form_component={{
							label: t('請再次輸入密碼'),
							sub_label: ''
						}}
					/>
					<input
						type="password"
						name="confirm_password"
						placeholder={t('請再次輸入密碼')}
						className="form-control-sm mb-3 form-control"
						id="confirm-password"
						value={confirmPassword}
						onChange={changeConfirmPassword}
						onBlur={handleConfirmBlur}
					/>
				</div>
			</div>
		</>
	);
}

export default PasswordFields;